import Page from "@/components/layout/Page";

export default function Headway() {
  return (
    <div className="min-h-screen overflow-hidden bg-gradient-to-b from-[#020817] via-[#04151F] to-[#020817] text-slate-50">
      <Page>
        <section className="w-full pb-24">
          <div className="max-w-[1280px] mx-auto px-6">
          <h1 className="text-[54px] leading-[1.1] font-bold mb-6 page-title-gradient">Headway</h1>
          
          <div className="space-y-6 max-w-3xl">
            <p className="text-xl text-muted-foreground leading-relaxed">
              Feedback from Headway organizations supporting brain injury survivors with our sensory products.
            </p>
            
            <p className="text-lg leading-relaxed">
              Headway groups and brain injury rehabilitation centres use Samboards to support survivors in their recovery journeys. Our tactile sensory tools help with sensory retraining, cognitive stimulation, and emotional wellbeing during rehabilitation.
            </p>
            
            <p className="text-lg leading-relaxed">
              The feedback from Headway professionals highlights how sensory engagement supports recovery, reduces anxiety, and provides meaningful activity for brain injury survivors at all stages of their rehabilitation.
            </p>
          </div>
        </div>
      </section>
      </Page>
    </div>
  );
}
